import '.g{display:flex;}.ssr-plugin'
import '.a5{flex-direction:row;}.ssr-plugin'
import { Property } from 'csstype'
import { Style, styled } from 'inlines'
import { ReactNode } from 'react'

const Row = ({
  gap = '1rem',
  alignItems = 'normal',
  style,
  onClick,
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  alignItems?: Property.AlignItems
  style?: Style
  onClick?: React.MouseEventHandler<HTMLDivElement>
  children: ReactNode
}) => {
  return (
    <styled.div className="g a5"
      onClick={onClick}
      style={{
        gap,
        alignItems,
        ...style,
      }}
    >
      {children}
    </styled.div>
  )
}

export default Row
